module.exports = __webpack_public_path__ + "img/桑寄生.84654095.jpg";